// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { tag16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-tag': IconTag;
    }
}

/**
 * The icon component for the 'tag' icon
 */
export class IconTag extends IconSvg {
    public constructor() {
        super(tag16X16);
    }
}

registerIconSvg('icon-tag', IconTag);
export const iconTagTag = 'nimble-icon-tag';
